// 系统抽题
<template>
    <div class="sys-sam">
        <div class="xy-start flex-wrap">
            <!-- <div class="xy-center jf-start item">
                <div class="name">所属科目:</div>
                <el-input
                    v-model="queInfo.subject"
                    placeholder="请输入科目关键字"
                ></el-input>
            </div> -->
            <div class="xy-center jf-start item">
                <div class="name">类型:</div>
                <el-cascader :options="chooseQuesOptions" :props="{ emitPath: false }" v-model="currentChoose" style="margin-right: 20px"/>
                <div class="name">科室:</div>
                <el-cascader
                    ref="cascader"
                    placeholder="请输入科目或科室关键字检索..."
                    :show-all-levels="false"
                    :props="categoryProps"
                    :options="categoryInfo"
                    :filter-method="dataFilter"
                    filterable
                    v-model="queInfo.department"
                    @change="CategoryChange"
                    style="margin-top: -2px">
                    <template v-slot="{node, data}">
                        <span @click="clickCategory(node, data)">{{ data.text }}</span>
                    </template>
                </el-cascader>
            </div>
            <div class="xy-center jf-start item">
                <div class="name">题型:</div>
                <el-select
                    v-model="queInfo.queType"
                    placeholder="请选择"
                    clearable
                >
                    <el-option
                        v-for="item in queTypeData"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <el-input
                v-model="queInfo.searchKey"
                class="item search"
                placeholder="请输入试题关键字"
            >
                <template slot="append"
                    ><div
                        class="pointer"
                        @click="
                            () => {
                                currentPage = 1;
                                fetchList();
                            }
                        "
                    >
                        检索
                    </div></template
                >
            </el-input>
        </div>
        <div v-show="currentChoose === 'custom'">
            <el-table
                :data="tableData"
                height="350"
                border
                style="width: 100%"
                class="el-table"
                v-loading="flag.loading"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                >
                </el-table-column>
                <el-table-column prop="Content" label="试题">
                    <template v-slot="scoped">
                        <table-que :data="scoped.row"></table-que>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="ClassId"
                    label="科目"
                    width="100"
                    align="center"
                >
                    <span>{{ departmentName }}</span>
                </el-table-column>
                <el-table-column
                    prop="SubjectType"
                    label="题型"
                    width="70"
                    align="center"
                >
                    <template v-slot="scoped">
                        <div>
                            {{
                                (
                                    queTypeData.find(
                                        (item) =>
                                            item.value === scoped.row.SubjectType
                                    ) || {}
                                ).name
                            }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="AddTime"
                    label="创建时间"
                    width="150"
                    align="center"
                >
                    <template slot-scope="scoped">
                        <span>{{ scoped.row.AddTime.substring(0, 10) }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination xy-center mt-15">
                <el-pagination
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    layout="total, prev, pager, next"
                    :total="count"
                >
                </el-pagination>
            </div>
        </div>
        <div v-show="currentChoose === 'random'">
            <choose-ques v-model="quesNum" :ques-num="count"/>
        </div>
    </div>
</template>

<script>
import ChooseQues from "../ChooseQues";
import { CommonPage } from "@/mixins/commonData";
import { GetOrganClassLit, GetPulicQuestionInfo } from "@/api/questionPaper.js";
import { GetSystemCategoryInfo } from "@/api/course";

import tableQue from "../tableQue.vue";
import { removeEmptyChildren } from "@/utils";
import { getChooseQuesType } from "@/components/manager/resource/chooseType/config";
import { GetPulicQuestionList } from "@/api/questionPaper";
import {random} from "lodash";
export default {
    components: { tableQue, ChooseQues },
    mixins: [CommonPage],
    data() {
        return {
            categoryProps: {
                value: "id",
                label: "name",
                children: "children",
                expandTrigger: "hover",
                checkStrictly: true,
            },
            currentChoose: "custom",
            quesNum: 1,
            chooseQuesOptions: getChooseQuesType("system"),
            categoryInfo: [],
            totalCount: 10,
            queInfo: {
                subject: "", // 科目
                department: "", // 科室
                queType: "",
                searchKey: "",
            },
            tableData: [],
            currentPage: 1,
            count: 0,
            flag: {
                loading: false,
            },
            organClass: [],
            multipleSelection: [],
            departmentName: "",
        };
    },
    mounted() {
        // this.fetchList();
        this.fetchOrganClass();
        this.GetSystemCategoryInfo();
    },
    methods: {
        // 获取科目
        async GetSystemCategoryInfo() {
            try {
                const { data } = await GetSystemCategoryInfo();
                removeEmptyChildren(data.data, "children")
                const path = []
                const getFirstOption = (data) => {
                    if (Array.isArray(data.children) && data.children.length > 0) {
                        path.push(data.id)
                        getFirstOption(data.children[0])
                    } else {
                        path.push(data.id)
                        return data.id
                    }
                }
                if (Array.isArray(data.data) && data.data.length > 0) {
                    getFirstOption(data.data[0] || Object.create(null))
                    this.queInfo.department = path
                    this.categoryInfo = data.data;
                    this.fetchList()
                }
            } catch (err) {
                this.$message("获取科目发生异常！", "error");
            }
        },
        clickCategory(node, data) {
            this.queInfo.department = node.path;
            this.CategoryChange(this.queInfo.department)
        },
        fetchOrganClass() {
            GetOrganClassLit().then((res) => {
                const data = res.data.data;
                // console.log("data:", data);
                let newData = [];
                const work = (vl, pIds) => {
                    for (let i = 0; i < vl.length; i++) {
                        newData.push({
                            label: vl[i].label,
                            value: vl[i].value,
                            parentIds: pIds,
                        });
                        if (vl[i].children.length) {
                            work(vl[i].children, pIds.concat([vl[i].value]));
                        }
                    }
                };
                work(data, []);
                // console.log("newData:", newData);
                this.organClass = newData;
            });
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchList();
        },
        fetchList() {
            this.flagPromise([
                GetPulicQuestionInfo({
                    questionType: this.queInfo.queType + "",
                    category: this.queInfo.department[this.queInfo.department.length - 1],
                    keyWord: this.queInfo.searchKey,
                    pageNo: this.currentPage,
                }),
            ]).then(([res]) => {
                this.count = res.data.count;
                this.tableData = res.data.data;
                this.quesNum = Math.min(1, res.data.count)
            });
        },
        CategoryChange(val) {
            if (!val.length) return;
            // this.queInfo.department = val[(val || []).length - 1];
            let department = val[(val || []).length - 1];
            console.log(val);
            this.fetchList();
            const work = (list) => {
                if (!list || !list.length) return;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === department) {
                        this.departmentName = list[i].title;
                        break;
                    } else {
                        work(list[i].children);
                    }
                }
            };

            work(this.categoryInfo);

            // console.log(this.departmentName);
        },
        // 科目过滤
        dataFilter(node, val) {
            if (
                !!~node.text.indexOf(val) ||
                !!~node.text.toUpperCase().indexOf(val.toUpperCase())
            ) {
                return true;
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 获取选中的试题
        getSelectQuestion () {
            return new Promise((resolve, reject) => {
                if (this.currentChoose === "custom") {
                    resolve(this.multipleSelection)
                } else {
                    GetPulicQuestionList({
                        questionType: this.queInfo.queType + "",
                        category: this.queInfo.department[this.queInfo.department.length - 1],
                        keyWord: this.queInfo.searchKey,
                        pageNo: this.currentPage,
                        Count: this.quesNum
                    }).then((res) => {
                        resolve(res.data.data)
                    }).catch(reject)
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.sys-sam ::v-deep {
    .item {
        margin-top: 30px;
        margin-right: 50px;
        .name {
            white-space: nowrap;
            width: 4.5em;
            font-size: 16px;
            text-align: right;
            padding-right: 5px;
            box-sizing: border-box;
        }
    }
    .el-input {
        width: 180px;
        height: 34px;
        input {
            height: 34px;
            ::placeholder {
                font-size: 16px;
            }
        }
    }
    .search {
        width: 220px;
        .el-input-group__append {
            background: #1677ff;
            color: white;
            border-color: #1677ff;
        }
    }

    .el-table {
        margin-top: 40px;
    }
}
</style>
